import { months } from './budgetHierarchyUtils';

export const isBudgetValueInvalid = (value, refValue, budgetType) => {
    const roundedValue = Math.round(Number(value) || 0);
    const roundedRef = Math.round(Number(refValue) || 0);
    if (roundedRef <= 0) return false;
    const type = String(budgetType || '').toUpperCase();
    if (type === 'INTERNAL') return roundedValue > roundedRef;
    if (type === 'EXTERNAL') return roundedValue < roundedRef;
    return false;
};

export const findBudgetViolations = (budgetData, budgetType, territoryId, onlyRowIds = null) => {
    const invalidRows = [];

    (budgetData || []).forEach(row => {
        if (row.type !== 'PRODUCT' || String(row.territoryId) !== String(territoryId)) return;
        if (onlyRowIds && !onlyRowIds.has(String(row.id))) return;

        const badMonths = months.filter(m => isBudgetValueInvalid(row[m], row[`ref_${m}`], budgetType));

        if (badMonths.length > 0) {
            invalidRows.push({
                id: String(row.id),
                name: row.name,
                hierarchy: row.hierarchy?.join(' > '),
                months: badMonths.map(m => m.toUpperCase()),
            });
        }
    });

    return invalidRows;
};

export const buildViolationRejection = (invalidRows, budgetType) => ({
    message: String(budgetType).toUpperCase() === 'INTERNAL'
        ? 'Internal budget cannot exceed the External budget. Please correct the highlighted rows.'
        : 'External budget cannot be less than the Internal budget. Please correct the highlighted rows.',
    invalidRowIds: invalidRows.map(r => r.id),
    invalidRows,
});
